
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18nModule } from '@spartacus/core';

@Component({
    selector: 'app-order-tracking-status-popup',
    imports: [I18nModule],
    templateUrl: './order-tracking-status-popup.component.html',
    styleUrl: './order-tracking-status-popup.component.scss'
})
export class OrderTrackingStatusPopupComponent {
  dialogRef = inject(MatDialogRef<OrderTrackingStatusPopupComponent>)
  data = inject(MAT_DIALOG_DATA);

  closeDialog() {
    this.dialogRef.close(false);
  }
}
